/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Some fat is essential — very low body fat carries health risks. Healthy ranges differ by sex and age.`)
};

const es_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Algo de grasa es esencial — un porcentaje de grasa corporal muy bajo conlleva riesgos para la salud. Los rangos saludables varían según el sexo y la edad.`)
};

const de_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Ein gewisses Fett ist lebensnotwendig — ein sehr niedriger Körperfettanteil birgt gesundheitliche Risiken. Gesunde Bereiche unterscheiden sich nach Geschlecht und Alter.`)
};

const nl_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Een beetje vet is essentieel — een zeer laag lichaamsvetpercentage brengt gezondheidsrisico's met zich mee. Gezonde bereiken verschillen per geslacht en leeftijd.`)
};

const fr_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Une certaine graisse est essentielle — une masse grasse très basse comporte des risques pour la santé. Les fourchettes saines varient selon le sexe et l'âge.`)
};

const it_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Un po' di grasso è essenziale — un grasso corporeo troppo basso comporta rischi per la salute. I livelli sani variano in base a sesso ed età.`)
};

const pt_br2_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma parte da gordura é essencial — níveis muito baixos trazem riscos à saúde. As faixas saudáveis variam por sexo e idade.`)
};

const pt_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Alguma gordura é essencial — uma gordura corporal muito baixa acarreta riscos de saúde. Os intervalos saudáveis variam consoante o sexo e a idade.`)
};

const ja_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。体脂肪の一部は必須であり、体脂肪率が極端に低いと健康リスクがあります。健康的な範囲は性別と年齢によって異なります。`)
};

const zh_bf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。一定量的体脂是必需的——体脂率过低会带来健康风险。健康范围因性别和年龄而异。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_a4", locale)
	if (locale === "en") return en_bf_faq_a4(inputs)
	if (locale === "es") return es_bf_faq_a4(inputs)
	if (locale === "de") return de_bf_faq_a4(inputs)
	if (locale === "nl") return nl_bf_faq_a4(inputs)
	if (locale === "fr") return fr_bf_faq_a4(inputs)
	if (locale === "it") return it_bf_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_a4(inputs)
	if (locale === "pt") return pt_bf_faq_a4(inputs)
	if (locale === "ja") return ja_bf_faq_a4(inputs)
	return zh_bf_faq_a4(inputs)
};